import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service';

@Component({
  selector: 'app-o2-reject-reason-modal',
  templateUrl: './o2-reject-reason-modal.component.html',
  styleUrls: ['./o2-reject-reason-modal.component.css']
})
export class O2RejectReasonModalComponent implements OnInit {

  remark: string = "";

  constructor(
    private dialogRef: MatDialogRef<O2RejectReasonModalComponent>,
    private alertMessage: AlertMessageService
  ) { }

  ngOnInit() {
  }

  saveReason() {
    if (this.remark == undefined || this.remark == null || this.remark == "" || this.remark.length == 0) {
      this.alertMessage.open({
        message: "กรุณาระบุเหตุผลที่ไม่อนุมัติเอกสาร",
        title: ""
      });

      return;
    }

    this.dialogRef.close(this.remark);
  }

}
